import React from "react";
import { Formik, Form, Field } from "formik";
import {
  Button,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import { TextField, Select, Switch } from "formik-mui";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";

import { useUser } from "../../../../auth/UserProvider";
import { addOrEditFilter } from "../../../../store/ducks/duckFilter";
import { BorderLinearProgress } from "../../../../components/LoadingComponent";

const FilterForm = (props) => {
  const { initialValues, isEdit, handleClose, open } = props;

  const { enqueueSnackbar } = useSnackbar();

  const { isAdmin } = useUser();

  const dispatch = useDispatch();

  return (
    <>
      <Formik
        initialValues={initialValues}
        validate={(values) => {
          let errors = {};

          if (!values.name) {
            errors.name = "Required";
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          let message = values.id > 0 ? "Edited" : "Added";

          return dispatch(addOrEditFilter(values)).then(() => {
            handleClose();
            setSubmitting(false);
            enqueueSnackbar(`${message} '${values.name}' Filter Successfully`, {
              variant: "success",
            });
          });
        }}
      >
        {({ submitForm, isSubmitting, values }) => (
          <Form>
            <Dialog
              fullWidth
              aria-labelledby="form-dialog-title"
              maxWidth="xs"
              open={open}
              onClose={handleClose}
            >
              {isSubmitting && <BorderLinearProgress />}
              <DialogTitle id="form-dialog-title">
                {isEdit && initialValues.id !== 0
                  ? "Edit"
                  : !isEdit && initialValues.id !== 0
                    ? "Details"
                    : "Add"}
                {initialValues.deleted && isAdmin && (
                  <>
                    <FormControlLabel
                      control={
                        <Field color="primary" component={Switch} name="deleted" type="checkbox" />
                      }
                      label="Deleted"
                      labelPlacement="start"
                      style={{ marginRight: 0, marginLeft: "70%" }}
                    />
                    <FormHelperText
                      style={{
                        marginRight: "5%",
                        textAlign: "right",
                      }}
                    >
                      {values?.deleted ? "Enable" : "Disable"}
                    </FormHelperText>
                  </>
                )}
              </DialogTitle>
              <DialogContent style={{ overflow: "hidden" }}>
                <Grid container spacing={4} styles={{ margin: "auto" }}>
                  <Grid item xs={4}>
                    <Field
                      component={TextField}
                      label="Name"
                      margin="dense"
                      name="name"
                      type="text"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl fullWidth margin="dense" variant="outlined">
                      <InputLabel id={`Label-Type`}>Type</InputLabel>
                      <Field
                        component={Select}
                        inputProps={{
                          variant: "outlined",
                          fullWidth: true,
                        }}
                        label="Type"
                        labelId={"Label-Type"}
                        margin="dense"
                        name="type"
                        style={{ width: "100%", height: "100%" }}
                        type="text"
                        variant="outlined"
                      >
                        <MenuItem value="Normal">{"Normal"}</MenuItem>
                        <MenuItem value="Custom">{"Custom"}</MenuItem>
                      </Field>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <Field
                      fullWidth
                      InputProps={{ inputProps: { min: 1, max: 12 } }}
                      component={TextField}
                      label="Position Number"
                      margin="dense"
                      name="positionNumber"
                      type="number"
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={4} styles={{ margin: "auto" }}>
                  <Grid item xs={4}>
                    <Field
                      fullWidth
                      InputProps={{ inputProps: { min: 1, max: 12 } }}
                      component={TextField}
                      id="parameter"
                      label="Parameter"
                      margin="dense"
                      name="parameter"
                      type="text"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Field
                      fullWidth
                      component={TextField}
                      id="stringToMatch"
                      label="String To Match"
                      margin="dense"
                      name="stringToMatch"
                      type="text"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Field
                      fullWidth
                      component={TextField}
                      id="tag"
                      label="Tag"
                      margin="dense"
                      name="tag"
                      type="text"
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
                {/* </Grid> */}
              </DialogContent>
              <DialogActions>
                <Button color="primary" variant="contained" onClick={handleClose}>
                  Close
                </Button>
                {isEdit && (
                  <Button color="primary" variant="contained" onClick={submitForm}>
                    Save
                  </Button>
                )}
              </DialogActions>
            </Dialog>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default FilterForm;
